import getBasePath from '@/common/functions/api-resource';
import resourceBuilder from '../functions/metadados-resource-builder';

const basePath = getBasePath('recebimento', 'nota-debito/consulta');

const notaDebitoActions = {
  buscaDivisoes: { method: 'GET', url: `${basePath}/divisao` },
  verificarDadosExportacao: { methods: 'GET', url: `${basePath}/verificar-dados-exportacao` },
  verificarAgrupamentoFornecedorPagador: { methods: 'GET', url: `${basePath}/verificar-agrupado-fornecedor-pagador` },
  alteraStatusNotaParaPendenteIntegracao: { method: 'PUT', url: `${basePath}/altera-status-para-pendente-integracao/{idNotaDebito}` },
};

export const buscaNotas = (parametros, resource) => resourceBuilder.buildGET(resource, basePath, '', parametros).doGet();

export default (resource) => resource(`${basePath}`, {}, notaDebitoActions);
